<template>
  <div class="q-w360 q-fit">
    <question-with-error-wrap :error="getFieldsError(['ethnicity', 'otherEthnicity'])">
      <multi-answer-question
        title="label.myEthnicity"
        :max-answers="2"
        :value="ethnicity"
        :other-value="otherEthnicity"
        :options="$options.ethnicityOptions"
        @input="onFieldChange('ethnicity', $event)"
        @other-input="onFieldChange('otherEthnicity', $event)"
      />
    </question-with-error-wrap>
  </div>
</template>

<script>
import QuestionWithErrorWrap from '@/modules/questionnaire/new-design-components/questions/QuestionWithErrorWrap.vue';
import MultiAnswerQuestion from '@/modules/questionnaire/new-design-components/questions/multi-answer-question/MultiAnswerQuestion.vue';

import { stepTemplateMixin } from '@/modules/questionnaire/mixins/stepTemplateMixin';

import { ETHNICITY, OTHER_VALUE_INCLUSIVE_BINDINGS } from '@/modules/questionnaire/api/constants';

const ETHNICITY_OPTIONS = [
  { value: ETHNICITY.CAUSCASIAN, text: 'ethnicity.caucasian' },
  { value: ETHNICITY.AFRICAN, text: 'ethnicity.african' },
  { value: ETHNICITY.MIDDLE_EATERN, text: 'ethnicity.middleEastern' },
  { value: ETHNICITY.ASIAN, text: 'ethnicity.asian' },
  { value: ETHNICITY.INDIAN, text: 'ethnicity.indian' },
  { value: ETHNICITY.LATIN_AMERICAN, text: 'ethnicity.latinAmerican' },
  { ...OTHER_VALUE_INCLUSIVE_BINDINGS }
];

export default {
  name: 'EthnicBackgroundTemplate',
  components: { MultiAnswerQuestion, QuestionWithErrorWrap },
  mixins: [stepTemplateMixin],
  ethnicityOptions: ETHNICITY_OPTIONS,
  props: {
    ethnicity: {
      type: Array,
      required: true
    },
    otherEthnicity: {
      type: String,
      required: true
    }
  }
};
</script>
